
// display feather icons
export function updateFeatherIcons() {
  feather.replace({ 'stroke-width': 1.5 })
}

